export const CONTAINERS = {
  MEDIA: 'media',
  READER_REQUESTS: 'reader-requests'
};
